import useSWR from "swr";
import { userClient } from "../clients";
import { useMemo } from "react";
import * as openpgp from 'openpgp';
import { expand } from "lib/e2ee/helper";
import { useXdStorageContext } from "lib/storage";
import { v4 as uuid } from 'uuid';

const fetcher = async (_key, nonce) => {
  try {
    const { data } = await userClient.getUser();

    if (data.public_key_armored) {
      data.publicKey = await openpgp.readKey({ armoredKey: expand(data.public_key_armored) });
    }

    if (data.nonce_key_armored && nonce) {
      try {
        data.privateKey = await openpgp.decryptKey({
          privateKey: await openpgp.readPrivateKey({ armoredKey: expand(data.nonce_key_armored) }),
          passphrase: nonce
        });
      }
      catch(e){
        // A nonce password is set, it just isn't the correct one so clear it out
        data.nonce_key_armored = null;
      }
    }

    data.avatarKey = uuid();

    return data;
  } catch (err) {
    console.log(err)
    throw err;
  }
}

export const useLoggedinUser = () => {
  const { isLoaded, storage } = useXdStorageContext();
  const { data, error, isValidating, mutate } = useSWR(isLoaded ? ['user/me', storage.packs_nonce] : null, fetcher, { revalidateIfStale: false, revalidateOnFocus: false });

  const isVerified = useMemo(() => {
    return data && data?.verified;
  }, [ data ]);

  return {
    data: !error ? data : null,
    error,
    isLoggedIn: (data && error?.response?.status !== 401),
    isLoading: !data && !error,
    isValidating,
    isVerified,
    mutate,
  }
}
